import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import { connect } from 'react-redux';

import axios from 'axios';

import styled from 'styled-components';
import { apiEndpoints } from '../../config/config';

import SingleNews from './single-news/SingleNews';
import SingleReview from './single-review/SingleReview';
import SingleBestOf from './single-best-of/SingleBestOf';
import SingleT3 from './single-t3/SingleT3';
// import SingleArticleLoader from '../common/Loaders/SingleArticleLoader';

const Container = styled.div.attrs({
  className: 'w-100'
})`
  background: #fff;
`;

class SingleArticle extends Component {
  state = {
    type: null
  };

  componentDidUpdate = (prevProps, prevState) => {
    let slug, url;
    slug = this.props.history.location.pathname.slice(1);
    url = `${apiEndpoints.singlePostType}/${slug}`;
    axios.get(url).then(res => {
      // console.log('res: ', res);
      // if (res.data.success === 1) {
      //   this.setState({ type: res.data.singleCategory.categoryName });
      // }
      if (res.data && res.data.singleCategory) {
        const postId = res.data.singleCategory.postId;
        const url = `${apiEndpoints.increasePostCount}/${postId}`;
        const response = axios.post(url);
        response
          .then(data => {
            // console.log('data: ', data);
          })
          .catch(err => {
            // console.log('err: ', err);
          });
      }
    });
  };

  componentDidMount = () => {
    let slug, url;
    slug = this.props.history.location.pathname.slice(1);
    // console.log('slug: ', slug);
    url = `${apiEndpoints.singlePostType}/${slug}`;
    // console.log('url: ', url);
    axios.get(url).then(res => {
      // console.log('res: ', res);
      if (res.data.success === 1) {
        this.setState({ type: res.data.singleCategory.categoryName });
      } else {
        this.setState({ type: 'News' });
      }
      if (res.data && res.data.singleCategory) {
        const postId = res.data.singleCategory.postId;
        const url = `${apiEndpoints.increasePostCount}/${postId}`;
        const response = axios.post(url);
        response
          .then(data => {
            // console.log('data: ', data);
          })
          .catch(err => console.log('err: ', err));
      }
    });
  };

  render() {
    // console.log('this.state: ', this.state);
    let page = null;
    if (this.state.type) {
      switch (this.state.type) {
        case 'News':
          page = <SingleNews />;
          break;
        case 'Reviews':
          page = <SingleReview />;
          break;
        case 'How To':
          page = <SingleT3 />;
          break;
        case 'BestOf':
          page = <SingleBestOf />;
          break;
        case 'Internet':
          page = <SingleT3 />;
          break;
        default:
          page = <SingleNews />;
          break;
      }
    }
    return <Container>{page}</Container>;
    // return <Container>{page ? page : <SingleArticleLoader />}</Container>;
  }
}

export default withRouter(SingleArticle);
